import { boot } from './app.js';

// 起動に失敗しても「見た目は正常だが何を押しても無反応」で終わらせない。
// （実例: CSP が WebAssembly を禁止していて依存モジュールの評価が落ちた）
try {
  boot();
} catch (err){
  console.error(err);
  const el = document.querySelector('#dropError');
  if(el){ el.textContent = `起動に失敗しました: ${err?.message || err}`; el.hidden = false; }
}
